export const routes = [
  {
    path: '/sala-principal/:id/sala-indicadores',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'sala.indicadores.list',
    meta: {
      requiresAuth: true
    }
  }
]
